module.exports = __webpack_public_path__ + "assets/img/Logo.26903a9e.png";